<template>
    <NuxtLayout name="malt-full-layout">
        <slot />
    </NuxtLayout>
</template>

<script setup lang="ts">
    import {use3rdParties} from '#imports';

    use3rdParties();
</script>
